import { render, staticRenderFns } from "./Luckylist.vue?vue&type=template&id=a4bb56c6&scoped=true"
import script from "./Luckylist.vue?vue&type=script&lang=js"
export * from "./Luckylist.vue?vue&type=script&lang=js"
import style0 from "./Luckylist.vue?vue&type=style&index=0&id=a4bb56c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bb56c6",
  null
  
)

export default component.exports